// extracted by mini-css-extract-plugin
export default {"questionContainer":"Question_questionContainer__UVMG2","questionrow":"Question_questionrow__DqXlF","heading":"Question_heading__HzjwA"};